import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../constant";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import coinIcon from "../../images/site_logo/TC-Logo-icon.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const AccountAdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1); // 1 = Login, 2 = OTP
  const [adminId, setAdminId] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/account-admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.status === 403 && data.requires_otp) {
        setAdminId(data.user_id);
        setStep(2);
        setError(""); // Clear any previous errors
      } else if (response.ok && data.access_token) {
        localStorage.setItem("account_admin_token", data.access_token);
        navigate("/account-admin");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/account-admin/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ user_id: adminId, otp: otp }),
      });

      const data = await response.json();

      if (response.ok && data.access_token) {
        localStorage.setItem("account_admin_token", data.access_token);
        navigate("/account-admin");
      } else {
        setError(data.message || "Invalid OTP");
      }
    } catch (err) {
      setError("An error occurred during OTP verification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper" style={{marginTop:"10vh"}}>
      <Header />
      <div
        className="login-section py-4 pt-5"
        style={{
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#001964",
          marginBottom: "0px",
          borderRadius: "20px",
          padding: "clamp(15px, 4vw, 30px)",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-8 col-sm-10">
              <div
                className="bg-white text-center shadow p-4 margin-top-lg mx-auto"
                style={{
                  color: "#000",
                  borderRadius: "20px",
                  maxWidth: "500px",
                  marginTop: "0px",
                  marginBottom: "40px",
                  padding: "clamp(20px, 4vw, 30px)",
                }}
              >
                <div className="d-flex justify-content-center mb-0">
                  <img
                    src={coinIcon}
                    alt="TopCoin UK"
                    style={{
                      width: "clamp(80px, 15vw, 115px)",
                      height: "clamp(80px, 15vw, 115px)",
                    }}
                  />
                </div>

                <h4
                  className="fw-bold mb-1"
                  style={{
                    background: "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    display: "inline-block",
                    fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
                  }}
                >
                  Account Admin Portal
                </h4>

                <h3
                  className="sub-title mb-4"
                  style={{ fontSize: "clamp(0.9rem, 2.5vw, 1rem)" }}
                >
                  {step === 1 ? "Enter your Email and Password" : "Enter OTP sent to your email"}
                </h3>

                {error && (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "7px",
                      borderRadius: "8px",
                      margin: "10px 0",
                      fontWeight: "500",
                      fontSize: "0.9rem",
                      backgroundColor: "#ffebee",
                      color: "#c62828",
                      border: "1px solid #ffcdd2",
                    }}
                  >
                    {error}
                  </div>
                )}

                {step === 1 ? (
                  <form onSubmit={handleLogin} className="text-start mb-4">
                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold mb-0"
                        style={{
                          color: "#052C65",
                          fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                        }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control bg-white"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={loading}
                        style={{
                          borderRadius: "8px",
                          padding: "12px",
                          border: "1px solid #ccc",
                          color: "black",
                          fontSize: "16px",
                        }}
                       maxLength={255} />
                    </div>

                    <div className="mb-4 position-relative">
                      <label
                        className="form-label fw-semibold mb-0"
                        style={{
                          color: "#052C65",
                          fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                        }}
                      >
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          className="form-control bg-white"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          disabled={loading}
                          style={{
                            borderRadius: "8px",
                            padding: "12px",
                            border: "1px solid #ccc",
                            color: "black",
                            paddingRight: "40px",
                            fontSize: "16px",
                          }}
                         maxLength={255} />
                        <span
                          onClick={() => setPasswordVisible(!passwordVisible)}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "12px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#666",
                            zIndex: 2,
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {passwordVisible ? (
                            <FaEye size={18} />
                          ) : (
                            <FaEyeSlash size={18} />
                          )}
                        </span>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="w-100 text-white fw-bold py-2 mt-2"
                      disabled={loading}
                      style={{
                        backgroundColor: loading ? "#666" : "#0000A0",
                        borderRadius: "8px",
                        border: "none",
                        opacity: loading ? 0.7 : 1,
                        cursor: loading ? "not-allowed" : "pointer",
                        padding: "12px",
                        fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                      }}
                    >
                      {loading ? "Logging in..." : "SIGN IN"}
                    </button>
                  </form>
                ) : (
                  <form onSubmit={handleVerifyOTP} className="text-start mb-4">
                    <div className="mb-4">
                      <label
                        className="form-label fw-semibold mb-0"
                        style={{
                          color: "#052C65",
                          fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                        }}
                      >
                        OTP Code
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                        disabled={loading}
                        style={{
                          borderRadius: "8px",
                          padding: "12px",
                          border: "1px solid #ccc",
                          color: "black",
                          fontSize: "16px",
                        }}
                       maxLength={255} />
                    </div>

                    <button
                      type="submit"
                      className="w-100 text-white fw-bold py-2 mt-2"
                      disabled={loading}
                      style={{
                        backgroundColor: loading ? "#666" : "#0000A0",
                        borderRadius: "8px",
                        border: "none",
                        opacity: loading ? 0.7 : 1,
                        cursor: loading ? "not-allowed" : "pointer",
                        padding: "12px",
                        fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                      }}
                    >
                      {loading ? "Verifying..." : "VERIFY OTP"}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AccountAdminLogin;
